import { RenderIconDismiss } from "@/components/ui/Icons/IconsCustom";
import { RootState } from "@/redux";
import { ResourceInfo } from "@/services";
import {
  Button,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerHeaderTitle,
  Label,
  Text,
  Tooltip,
} from "@fluentui/react-components";
import { cloneDeep } from "lodash";
import { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { IResourceDetailProps } from "./Models";
import { ResourceDetailBaseWrapper, ResourceDetailItemWrapper } from "./Styles";
import { ResourceCalendarHeaderWrapper } from "../resource-calendar/Styles";

const ResourceDetail = forwardRef((_props: IResourceDetailProps, ref) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [resourceInfo, setResourceInfo] = useState<ResourceInfo | null>(null);

  const theme: string = useSelector(
    (state: RootState) => state.settingInfo?.theme
  ) as string;

  useImperativeHandle(ref, () => ({
    onOpenResourceDetail,
  }));

  const onOpenResourceDetail = (resourceInfo: ResourceInfo) => {
    setResourceInfo(cloneDeep(resourceInfo));
    setIsOpen(true);
  };

  const onDismiss = () => {
    setIsOpen(false);
    setResourceInfo(null);
  };

  return (
    <Drawer separator open={isOpen} size="full">
      {resourceInfo ? (
        <>
          <DrawerHeader>
            <DrawerHeaderTitle
              action={
                <Button
                  appearance="subtle"
                  aria-label="Close"
                  icon={<RenderIconDismiss theme={theme} />}
                  onClick={onDismiss}
                />
              }
            >
              <div className="header_custom">
                <div
                >
                  {/* <ResourceCalendarHeaderWrapper className="ResourceCalendarHeader">
                    <span>{resourceInfo.displayName} </span>
                  </ResourceCalendarHeaderWrapper> */}

                  <Tooltip content={resourceInfo.displayName || ""} relationship="label">
                    <ResourceCalendarHeaderWrapper >
                      <span className="resourceCalendarHeader truncate-text">{resourceInfo.displayName}</span>
                    </ResourceCalendarHeaderWrapper>
                  </Tooltip>

                </div>
              </div>
            </DrawerHeaderTitle>
          </DrawerHeader>
          <DrawerBody>
            {resourceInfo ? (
              <ResourceDetailBaseWrapper className="ResourceDetailBaseWrapper">
                <ResourceDetailItemWrapper className="ResourceDetailItemWrapper">
                  <Label weight="semibold">{t("Resource Name")}</Label>
                  <Text className="text">{resourceInfo.displayName}</Text>
                </ResourceDetailItemWrapper>
                <ResourceDetailItemWrapper className="ResourceDetailItemWrapper">
                  <Label weight="semibold">{t("Resource Mail")}</Label>
                  <Text className="text">{resourceInfo.displayEmail || resourceInfo.email}</Text>
                </ResourceDetailItemWrapper>
                <ResourceDetailItemWrapper className="ResourceDetailItemWrapper">
                  <Label weight="semibold">{t("Location")}</Label>
                  <Text className="text">{resourceInfo.locationDisplayName}</Text>
                </ResourceDetailItemWrapper>
                <ResourceDetailItemWrapper className="ResourceDetailItemWrapper">
                  <Label weight="semibold">{t("Resource type")}</Label>
                  <Text className="text">{resourceInfo.resourceType}</Text>
                </ResourceDetailItemWrapper>
              </ResourceDetailBaseWrapper>
            ) : null}
          </DrawerBody>
        </>
      ) : null}
    </Drawer>
  );
});

export default ResourceDetail;
